import { useWidgetTokenStore } from '@elfsight/lib-utils';
import { Form as LibForm } from '@elfsight/widget-form-builder/widget';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../constants';
import { useFormPopup } from '../form-popup-context';
import { FormLayout } from './form-layout';

const { appAlias } = meta;

export function Form() {
  const { editMode } = useSettings();
  const widgetTokenStore = useWidgetTokenStore();

  const { formSettings, onFormSubmit } = useFormPopup();

  const { fields } = formSettings;

  return (
    <LibForm
      {...formSettings}
      fields={fields}
      widgetToken={widgetTokenStore.get()}
      onSubmitSuccessful={onFormSubmit}
      editMode={editMode}
      submitAdditionalData={{
        type: appAlias
      }}
    >
      {/* @ts-expect-error fields, displayedFields и onSubmit передаются в FormLayout через cloneElement */}
      <FormLayout />
    </LibForm>
  );
}
